module.exports = "/_next/static/images/Hero@2x-cad8703e7286b71b2b06bb329d1a95f2.png";